import Vue from "vue";
import VueRouter from "vue-router";

// 要告诉 vue 使用 vueRouter
Vue.use(VueRouter);

import Case from "@/components/solicitation/Case";
import Login from "@/components/solicitation/Login";
import Agree from "@/components/solicitation/Agree";
import CaseBase from "@/components/solicitation/CaseBase";
import CaseData from "@/components/solicitation/CaseData";
import CaseRes from "@/components/solicitation/CaseRes";
import CaseIndex from "@/components/solicitation/CaseIndex";


import WxLogin from "@/components/wxsw/Login"
import WxCase from "@/components/wxsw/Case"
import WxIndex from "@/components/wxsw/Index"
import WxScore from "@/components/wxsw/Score"
import WxJudgeIndex from "@/components/wxsw/JudgeIndex"
import WxAgree from "@/components/wxsw/Agree"

import PlayerLogin from "@/components/answer/PlayerLogin"
import PlayerIndex from "@/components/answer/PlayerIndex";
import PlayerRegAnswer from "@/components/answer/PlayerRegAnswer";
import PlayerRegAnswerBtn from "@/components/answer/PlayerRegAnswerBtn";
import PlayerCompAnswer from "@/components/answer/PlayerCompAnswer";
import PlayerCompAnswerBtn from "@/components/answer/PlayerCompAnswerBtn";
import HostIndex from "./components/answer/HostIndex";
import HostComp from "@/components/answer/HostComp";
import HostReg from "./components/answer/HostReg";
import HostCheck from "@/components/answer/HostCheck";
import HostPlayer from "@/components/answer/HostPlayer";
// import Screen from "@/components/answer/Screen";

import Survey from "@/components/survey/Survey";

import VoteScreen from "@/components/vote/VoteScreen";
import Vote from "@/components/vote/Vote";
import VoteHost from "@/components/vote/Host";

import QPlayerLogin from "@/components/qkds/QPlayerLogin";
import QPlayerQuestion from "@/components/qkds/QPlayerQuestion";
import QHostIndex from "@/components/qkds/QHostIndex";
import QHostCheck from "@/components/qkds/QHostCheck";
import QScreen from "@/components/qkds/QScreen";
import QHostQuestion from "@/components/qkds/QHostQuestion";


import RepToken from "@/components/ksd/rep/RepToken";
import RepIndex from "@/components/ksd/rep/RepIndex";
import RepInfo from "@/components/ksd/rep/RepInfo";
import RepCode from "@/components/ksd/rep/RepCode";
import RepAddress from "@/components/ksd/rep/RepAddress";
import RepSearch from "@/components/ksd/rep/RepSearch";
import RepSearchResult from "@/components/ksd/rep/RepSearchResult";

import DocIndex from "@/components/ksd/doc/DocIndex";
import DocLearner from "@/components/ksd/doc/DocLearner";
import DocLearnerScore from "@/components/ksd/doc/DocLearnerScore";
import DocStar from "@/components/ksd/doc/DocStar";
import DocSurvey from "@/components/ksd/doc/DocSurvey";
import DocCase from "@/components/ksd/doc/DocCase";
import DocVideo from "@/components/ksd/doc/DocVideo";
import DocCode from "@/components/ksd/doc/DocCode";
import DocInfo from "@/components/ksd/doc/DocInfo";
import DocLogin from "@/components/ksd/doc/DocLogin";
import PDF from "@/components/ksd/pdf/PDF";
import DocAgree from "@/components/ksd/doc/DocAgree";
import DocPrivacy from "@/components/ksd/doc/DocPrivacy";


import JudgeLogin from "@/components/ksd/judge/JudgeLogin";
import JudgeInfo from "@/components/ksd/judge/JudgeInfo";
import JudgeCase from "@/components/ksd/judge/JudgeCase";
import JudgeScore from "@/components/ksd/judge/JudgeScore";
import JudgeSuccess from "@/components/ksd/judge/JudgeSuccess";
import JudgePay from "@/components/ksd/judge/JudgePay";
import Agreement from "@/components/umed/Agreement";
import AgreementInfo from "@/components/umed/AgreementInfo";
import BAgreementInfo from "@/components/umed/BAgreementInfo";

import HzIndex from "@/components/hz/HzIndex";
import HzSchedule from "@/components/hz/HzSchedule";
import HzHistory from "@/components/hz/HzHistory";
import HzWelcome from "@/components/hz/HzWelcome";
import HzPro from "@/components/hz/HzPro";
import HzInfo from "@/components/hz/HzInfo";
import ZB from "@/components/zb/ZB";


import PS from "@/components/hz/PlayerScore";
import JS from "@/components/hz/JusgeScore";
import JL from "@/components/hz/JudgeLogin";
// import PC from "@/components/hz/PlayerControl"

const routes = [
    {
        path: "/case",
        component: Case,
        meta: {
            title: "病例征集"
        }
    },
    {
        path:"/",
        component: Login,
        meta: {
            title: ""
        }
    },
    {
        path: "/agree",
        component: Agree,
        meta: {
            title: "知情同意"
        }
    },
    {
        path: "/caseBase",
        name:"caseBase",
        component: CaseBase,
        meta: {
            title: "病例征集"
        }
    },
    {
        path: "/caseData",
        component: CaseData,
        meta: {
            title: "病例征集"
        }
    },
    {
        path: "/caseRes",
        component: CaseRes,
        meta: {
            title: "病例征集"
        }
    },
    {
        path: "/caseIndex",
        component: CaseIndex,
        meta: {
            title: "病例征集"
        }
    },
    //微芯生物
    {
        path: "/wx_login",
        component: WxLogin,
        meta: {
            title: ""
        }
    },
    {
        path: "/wx_case",
        component: WxCase,
        meta: {
            title: ""
        }
    },
    {
        path: "/wx_index",
        component: WxIndex,
        meta: {
            title: ""
        }
    },
    {
        path: "/wx_score",
        component: WxScore,
        meta: {
            title: ""
        }
    },
    {
        path: "/wx_agree",
        component: WxAgree,
    },
    {
        path: "/wx_judge_index",
        component: WxJudgeIndex,
        meta: {
            title: ""
        }
    },
    {
        path: "/survey",
        component: Survey,
        meta: {
            title: "基层心血管一级预防调研"
        }
    },
    {
        path: "/playerLogin",
        component: PlayerLogin
    },
    {
        path: "/playerIndex",
        component: PlayerIndex
    },
    {
        path: "/PlayerRegAnswerBtn",
        component: PlayerRegAnswerBtn
    },
    {
        path: "/playerRegAnswer",
        component: PlayerRegAnswer
    },
    {
        path: "/playerCompAnswer",
        component: PlayerCompAnswer
    },
    {
        path: "/playerCompAnswerBtn",
        component: PlayerCompAnswerBtn
    },
    {
        path: "/hostComp",
        component: HostComp
    },
    {
        path: "/hostIndex",
        component: HostIndex
    },
    {
        path: "/hostReg",
        component: HostReg
    },
    {
        path: "/hostCheck",
        component: HostCheck
    },
    {
        path: "/hostPlayer",
        component: HostPlayer
    },
    // {
    //     path: "/screen",
    //     component: Screen
    // },
    {
        path: "/vscreen",
        component: VoteScreen
    },
    {
        path: "/vote",
        component: Vote
    },
    {
        path: "/vhost",
        component: VoteHost
    },
    {
        path: "/qplayerlogin",
        component: QPlayerLogin
    },
    {
        path: "/qplayerquestion",
        component: QPlayerQuestion
    },
    {
        path: "/qhostindex",
        component: QHostIndex
    },
    {
        path: "/qhostCheck",
        component: QHostCheck
    },
    {
        path: "/qScreen",
        component: QScreen
    },
    {
        path: "/qhostquestion",
        component: QHostQuestion
    },
    {
        path: "/reptoken",
        component: RepToken
    },
    {
        path: "/repIndex",
        component: RepIndex
    },
    {
        path: "/repInfo",
        component: RepInfo,
        meta: {
            keepAlive:true
        }
    },
    {
        path: "/repAddress",
        component: RepAddress
    },
    {
        path: "/repCode",
        component: RepCode
    },
    {
        path: "/docIndex",
        component: DocIndex
    },
    {
        path: "/docLearner",
        component: DocLearner
    },
    {
        name:"docLearnerScore",
        path: "/docLearnerScore",
        component: DocLearnerScore
    },
    {
        path: "/docStar",
        component: DocStar
    },
    {
        path: "/docSurvey",
        component: DocSurvey
    },
    {
        name: "docCase",
        path: "/docCase",
        component: DocCase,
        meta: {
            keepAlive:false
        }
    },
    {
        path: "/docVideo",
        name:"docVideo",
        component: DocVideo
    },
    {
        path: "/docCode",
        component: DocCode
    },
    {
        path: "/docInfo",
        component: DocInfo
    },
    {
      path: "/docLogin",
      component: DocLogin
    },
    {
        path: "/pdf",
        component: PDF
    },
    {
       path: "/docAgree",
       component: DocAgree
    },{
        path: "/docPrivacy",
        component: DocPrivacy,
    },
    {
        path: "/judgeLogin",
        component: JudgeLogin
    },
    {
        path: "/judgeInfo",
        component: JudgeInfo,
        meta: {
            keepAlive:true
        }
    },
    {
        path: "/judgeCase",
        component: JudgeCase
    },
    {
        path: "/judgeScore",
        component: JudgeScore
    },
    {
        path: "/judgeSuccess",
        component: JudgeSuccess
    },
    {
        path: "/judgePay",
        component: JudgePay
    },
    {
        path: "/repSearch",
        component: RepSearch
    },
    {
        path: "/repSearchResult",
        component: RepSearchResult
    },
    {
        path: "/agreement",
        component: Agreement
    },
    {
        path: "/agreementInfo",
        component: AgreementInfo
    },
    {
        path: "/bAgreementInfo",
        component: BAgreementInfo
    },
    {
        path: "/hz/index",
        component: HzIndex
    },
    {
        path: "/hz/schedule",
        component: HzSchedule
    },
    {
        path: "/hz/history",
        component: HzHistory
    },
    {
        path: "/hz/welcome",
        component: HzWelcome
    },
    {
        path: "/hz/info",
        component: HzInfo
    },
    {
        path: "/zb",
        component: ZB
    },
    {
        path: "/hz/pro",
        component: HzPro
    },
    {
        path: "/hz/ps",//打分项目-选手
        component: PS
    },
    {
        path: "/hz/js",//打分项目-专家
        component: JS
    },
    {
        path: "/hz/jl",//打分项目-专家登录
        component: JL
    },
    // {
    //     path: "/hz/pc",//打分项目-后台控制
    //     component: PC
    // }
    // {
    //     path: "/screen",
    //     name: "screen",
    //     component:()=>import("@/components/bulletscreen/Screen")
    // }
    {
        path: "/sign_info",
        name: "signinfo",
        component: ()=>import("@/components/sign/SignInfo")
    },
    {
        path: "/sign_Login",
        name: "signlogin",
        component: ()=>import("@/components/sign/SignLogin")
    },
    // {
    //     path: "/star/info",
    //     name: "starInfo",
    //     component: ()=>import("@/components/star/Info")
    // },
    // {
    //     path: "/star/vote",
    //     name: "starVote",
    //     component: ()=>import("@/components/star/Vote")
    // },
    {
        path:"/say/Agree",
        name:"sayAgree",
        component:()=>import("@/components/say/Info")
    },
    {
        path:"/say/info",
        name:"sayInfo",
        meta: {
            keepAlive:true
        },
        component:()=>import("@/components/say/Index")
    },
    {
        path:"/say/poster",
        name:"sayPoster",
        component:()=>import("@/components/say/Poster")
    },
    // {
    //     path:"/say/info",
    //     name:"sayInfo",
    //     component:()=>import("@/components/say/Agree")
    // },
    {
        path:"/question",
        name:"question",
        component:()=>import("@/components/question/Index")
    },
    {
        path:"/question/poster",
        name:"questionPoster",
        component:()=>import("@/components/question/Poster")
    },

]

var router = new VueRouter({
    mode: 'history',
    routes
})
export default router;

router.beforeEach(async (to, from, next) => {

    if (to.meta.title) {
        document.title = to.meta.title;
    }

    return next()
})
